import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { IEpRadioButtonData, EpButtonStyle, EpButtonSize, IEpToolTipModel, IEpTextBoxModel } from '@epicor/kinetic';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { SaleType, PageNames } from 'ep-bt-controls';
import { Branch, BisTrackSettingsAutomaticallyApplyWebTrackSalesOrders, CustomerContact, CustomerStatus } from 'ep-bt-field-agent-proxy';
import { Router, NavigationExtras } from '@angular/router';
import { QuickOrderModel } from '../../models/quick-order.model';
import { EpbtFaBistrackbranchesListComponent } from '../../list/epbt-fa-bistrackbranches-list/epbt-fa-bistrackbranches-list.component';
import { EpbtFaContactsService } from '../../services/epbt-fa-contacts.service';
import { EpbtFaQuickOrderSummaryService } from '../../services/epbt-fa-quick-order-summary.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-order-quote',
  templateUrl: './epbt-fa-quick-order-quote.component.html',
  styleUrls: ['./epbt-fa-quick-order-quote.component.scss']
})
export class EpbtFaQuickOrderQuoteComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;
  EpButtonSize = EpButtonSize;

  public transactionTypeData: Array<IEpRadioButtonData> = [{ value: 1, label: 'Order' },
  { value: 2, label: 'Quote' }];
  public salesTypeData: Array<IEpRadioButtonData> = [];

  quickOrderCustomerForm: FormGroup;
  submitted = false;
  taxAreaLabel = 'Tax Area*';
  errorCustomer: any;


  @ViewChild(EpbtFaBistrackbranchesListComponent, { static: false }) epbtFaBistrackbranchesListComponent: EpbtFaBistrackbranchesListComponent;
  @ViewChild('tooltipTemplate', { static: false }) tooltipTemplate: TemplateRef<any>;
  epToolTip: IEpToolTipModel = {
    filter: '.k-select'
  };

  customerTextBoxModel: IEpTextBoxModel = {
    id: 'customerTextBoxModel',
    autoFocus: true
  };

  constructor(private formBuilder: FormBuilder, private location: Location,
    public quickOrderService: EpbtFaQuickOrderService,
    private customerService: EpbtFaCustomerService,
    private router: Router,
    private contactsService: EpbtFaContactsService,
    public quickOrderSummaryService: EpbtFaQuickOrderSummaryService) {
    // window.addEventListener('storage', this.alertMessage.bind(this));
  }

  ngOnInit() {
    this.epToolTip.tooltipTemplate = this.tooltipTemplate;
    if (!this.quickOrderService.quickOrder) {
      this.quickOrderService.quickOrder = new QuickOrderModel();
    }


    this.quickOrderSummaryService.geti4goTrueTokenParameters((result: any) => {
    });

    // if (!this.quickOrderService.quickOrder) {
    //   if (localStorage.getItem("QuickOrder") === null) {
    //     this.quickOrderService.quickOrder = new QuickOrderModel();
    //   }
    //   else {
    //     this.quickOrderService.quickOrder = JSON.parse(localStorage.getItem("QuickOrder"));
    //   }
    // }
    // else {
    //   localStorage.setItem("QuickOrder", JSON.stringify(this.quickOrderService.quickOrder));
    // }

    if (this.quickOrderService.bisTrackSettings
      && this.quickOrderService.bisTrackSettings.automaticallyApplyWebTrackSalesOrders == BisTrackSettingsAutomaticallyApplyWebTrackSalesOrders.YesComplete) {
      this.salesTypeData = [
        { value: 1, label: 'Pickup Now' },
        { value: 2, label: 'Will Call' },
        { value: 3, label: 'Delivered' }
      ];

      if (!this.quickOrderService.quickOrder.selectedSalesType) {
        this.quickOrderService.quickOrder.selectedSalesType = SaleType.CollectLater;
      }
    } else {
      this.salesTypeData = [
        { value: 2, label: 'Will Call' },
        { value: 3, label: 'Delivered' }
      ];

      if (!this.quickOrderService.quickOrder.selectedSalesType) {
        this.quickOrderService.quickOrder.selectedSalesType = SaleType.CollectLater;
      }
    }

    if (this.quickOrderService.quickOrder.customer && this.quickOrderService.selectedBranchId != -1 &&
      this.quickOrderService.quickOrder.selectedSalesType && this.quickOrderService.quickOrder.deliveryAddress) {
      this.quickOrderService.SetDefaultTaxArea();
    }

    // this.quickOrderService.quickOrder.customer = this.customerService.selectedCustomer;
    this.quickOrderCustomerForm = this.formBuilder.group({
      customer: [this.quickOrderService.quickOrder.customer ? this.quickOrderService.quickOrder.customer.name : '', Validators.required],
      transactionType: [this.quickOrderService.selectedTransactionType],
      saleType: [this.quickOrderService.quickOrder.selectedSalesType],
      dateRequired: [this.quickOrderService.quickOrder.dateRequired ? this.quickOrderService.quickOrder.dateRequired : new Date()],
      customerRef: [this.quickOrderService.quickOrder.customerRef ? this.quickOrderService.quickOrder.customerRef : ''],
      contactName: [this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.name : ''], // name
      contact: [this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.telephone : ''], // telephone
      contactEmail: [this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.email : '', Validators.email], // email
      deliveryAddress: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.addressCode : ''],
      addressLine1: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address1 : ''],
      addressLine2: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address2 : ''],
      addressLine3: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address3 : ''],
      city: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.city : ''],
      state: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.county : ''],
      zipCode: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.postCode : ''],
      country: [this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.country : ''],
      specialInstructions: [this.quickOrderService.quickOrder.specialInstructions ? this.quickOrderService.quickOrder.specialInstructions : '']
    });

    this.quickOrderCustomerForm.valueChanges.subscribe(
      result => {
        this.storeData();
      }
    );
    this.disableOrderType();
  }

  // This will be use in html code for validation
  get frmFields() { return this.quickOrderCustomerForm.controls; }

  // Bind the existing values
  bindValuesToForm() {
    this.quickOrderCustomerForm.patchValue({
      customer: this.quickOrderService.quickOrder.customer ? this.quickOrderService.quickOrder.customer.name : '',
      transactionType: this.quickOrderService.selectedTransactionType,
      saleType: this.quickOrderService.quickOrder.selectedSalesType,
      dateRequired: this.quickOrderService.quickOrder.dateRequired ? this.quickOrderService.quickOrder.dateRequired : new Date(),
      customerRef: this.quickOrderService.quickOrder.customerRef,
      contactName: this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.name : '',
      contact: this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.telephone : '',
      contactEmail: this.quickOrderService.quickOrder.contact ? this.quickOrderService.quickOrder.contact.email : '',
      deliveryAddress: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.addressCode : '',
      addressLine1: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address1 : '',
      addressLine2: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address2 : '',
      addressLine3: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.address3 : '',
      city: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.city : '',
      state: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.county : '',
      zipCode: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.postCode : '',
      country: this.quickOrderService.quickOrder.deliveryAddress ? this.quickOrderService.quickOrder.deliveryAddress.country : '',
      specialInstructions: this.quickOrderService.quickOrder.specialInstructions
    });
  }

  // Store the data to respective properties
  storeData() {
    this.quickOrderService.selectedTransactionType = this.quickOrderCustomerForm.controls['transactionType'].value;
    this.quickOrderService.quickOrder.selectedSalesType = this.quickOrderCustomerForm.controls['saleType'].value;
    this.quickOrderService.quickOrder.dateRequired = this.quickOrderCustomerForm.controls['dateRequired'].value;
    this.quickOrderService.quickOrder.customerRef = this.quickOrderCustomerForm.controls['customerRef'].value;
    if (this.quickOrderService.quickOrder.contact && this.quickOrderService.quickOrder.contact.customerName) {
      this.quickOrderService.quickOrder.contact.name = this.quickOrderCustomerForm.controls['contactName'].value;
      this.quickOrderService.quickOrder.contact.telephone = this.quickOrderCustomerForm.controls['contact'].value;
      this.quickOrderService.quickOrder.contact.email = this.quickOrderCustomerForm.controls['contactEmail'].value;
    } else {
      this.quickOrderService.quickOrder.contact = new CustomerContact();
      this.quickOrderService.quickOrder.contact.name = this.quickOrderCustomerForm.controls['contactName'].value;
      this.quickOrderService.quickOrder.contact.telephone = this.quickOrderCustomerForm.controls['contact'].value;
      this.quickOrderService.quickOrder.contact.email = this.quickOrderCustomerForm.controls['contactEmail'].value;
    }
    if (this.quickOrderService.quickOrder.deliveryAddress && this.quickOrderService.quickOrder.deliveryAddress.addressCode) {
      this.quickOrderService.quickOrder.deliveryAddress.address1 = this.quickOrderCustomerForm.controls['addressLine1'].value;
      this.quickOrderService.quickOrder.deliveryAddress.address2 = this.quickOrderCustomerForm.controls['addressLine2'].value;
      this.quickOrderService.quickOrder.deliveryAddress.address3 = this.quickOrderCustomerForm.controls['addressLine3'].value;
      this.quickOrderService.quickOrder.deliveryAddress.city = this.quickOrderCustomerForm.controls['city'].value;
      // this.quickOrderService.quickOrder.deliveryAddress.province = this.quickOrderCustomerForm.controls["state"].value;
      this.quickOrderService.quickOrder.deliveryAddress.county = this.quickOrderCustomerForm.controls['state'].value;
      this.quickOrderService.quickOrder.deliveryAddress.postCode = this.quickOrderCustomerForm.controls['zipCode'].value;
      this.quickOrderService.quickOrder.deliveryAddress.country = this.quickOrderCustomerForm.controls['country'].value;
    }
    this.quickOrderService.quickOrder.specialInstructions = this.quickOrderCustomerForm.controls['specialInstructions'].value;
  }

  onTransactionTypeChange(event: any) {
    this.quickOrderService.selectedTransactionType = this.quickOrderCustomerForm.controls['transactionType'].value;
    this.quickOrderService.quickOrder.TransactionType = this.quickOrderCustomerForm.controls['transactionType'].value;
    this.onSubmit();
  }

  onSalesTypeChange(event: any) {
    this.quickOrderService.quickOrder.selectedSalesType = this.quickOrderCustomerForm.controls['saleType'].value;
    this.quickOrderService.SetDefaultTaxArea();
    this.onSubmit();
  }

  onValueChange(selectedValue: any): void {

    if (selectedValue instanceof Branch) {
      this.quickOrderService.selectedBranchId = selectedValue.branchID;
      this.quickOrderService.quickOrder.branch = selectedValue;
      this.quickOrderService.SetDefaultTaxArea();
    } else {
      this.quickOrderService.selectedTextAreaId = selectedValue.taxAreaID;
      this.quickOrderService.quickOrder.taxArea = selectedValue;
    }
    // console.log("Quick Order Value Change");
    // console.log(selectedValue);
  }

  cancelClicked() {
    this.location.back();
  }

  onSearchCustomerClick(event: any) {
    this.errorCustomer = '';
    const charCode = event == null ? null : (event.which) ? event.which : event.keyCode;
    if (charCode == null || charCode == 13) {
      const searchString = charCode == null ? this.quickOrderCustomerForm.controls['customer'].value : event.target.value;
      // var searchString = event.target.value;
      this.quickOrderCustomerForm.controls['customer'].setValue(searchString);
      // this.customerService.searchString = searchString;
      const navigationExtras: NavigationExtras = {
        queryParams: {
          'searchString': searchString
        }
      };
      this.customerService.fromPage = PageNames.QuickOrder;
      if (searchString) {
        this.customerService.getCustomers(searchString, 0, (customers: any) => {
          if (customers && customers.length == 1) {
            this.quickOrderService.quickOrder.deliveryAddress = null;
            this.quickOrderService.selectedTextAreaId = -1;
            this.quickOrderService.quickOrder.taxArea = null;
            this.quickOrderService.quickOrder.contact = null;
            this.customerService.selectedCustomer = customers[0];
            this.quickOrderService.setCustomer(customers[0], (flag: any) => {
              this.disableOrderType();
              this.bindValuesToForm();
              this.quickOrderService.SetDefaultTaxArea();
            });
          } else {
            // this.customerService.fromPage = PageNames.QuickOrder;
            this.router.navigate(['/home/customer'], navigationExtras);
          }
        });
      } else {
        // this.customerService.fromPage = PageNames.QuickOrder;
        this.router.navigate(['/home/customer'], navigationExtras);
      }
    }
  }
  disableOrderType() {
    this.transactionTypeData.find(item => item.value == 1).disabled = this.quickOrderService.isOrderDisable;
    this.quickOrderService.isOrderDisable = false;
  }

  // onSearchCustomerButtonClick(event: any) {
  //   this.customerService.fromPage = PageNames.QuickOrder;
  //   this.router.navigate(['/home/customer']);
  // }

  onSearchContactClick() {
    this.customerService.fromPage = PageNames.QuickOrder;
    this.contactsService.fromPage = PageNames.QuickOrder;
    this.customerService.selectedCustomer = this.quickOrderService.quickOrder.customer;
    this.router.navigate(['/home/contact']);
  }

  onSearchAddressClick() {
    this.customerService.fromPage = PageNames.QuickOrder;
    this.customerService.selectedCustomer = this.quickOrderService.quickOrder.customer;
    this.router.navigate(['/home/customer/address']);
  }


  onSubmit() {
    this.submitted = true;
    this.quickOrderService.customerFormFlag = true;
    this.quickOrderService.selectedTransactionType = this.quickOrderCustomerForm.controls['transactionType'].value;
    this.quickOrderService.quickOrder.TransactionType = this.quickOrderCustomerForm.controls['transactionType'].value;

    if (!this.validateCustomer() || this.quickOrderCustomerForm.invalid || this.quickOrderService.selectedTextAreaId <= 0 || this.quickOrderService.selectedBranchId < 0) {
      this.quickOrderService.customerFormFlag = false;
    } else {
      if (this.quickOrderService.selectedBranchId > 0 && !this.quickOrderService.quickOrder.branch) {
        const result = this.epbtFaBistrackbranchesListComponent.bisTrackBranches.filter(x => x.branchID == this.quickOrderService.selectedBranchId);
        this.quickOrderService.quickOrder.branch = result ? result[0] : null;
      }
      this.quickOrderService.customerFormFlag = true;
    }
  }

  payment() {
    localStorage.setItem('QuickOrder', JSON.stringify(this.quickOrderService.quickOrder));
    this.router.navigate([]).then(result => { window.open('/home/quickorder/payment', '_blank'); });
  }

  validateCustomer(): boolean {
    const searchCompetitorString = this.quickOrderCustomerForm.controls['customer'].value;
    if (!searchCompetitorString || !this.quickOrderService.quickOrder.customer) {
      this.errorCustomer = 'Please select a customer';
      return false;
    } else if (searchCompetitorString != this.quickOrderService.quickOrder.customer.name) {
      this.errorCustomer = 'Please select a customer';
      return false;
    } else {
      this.errorCustomer = '';
      return true;
    }
  }


  // setData() {
  //  localStorage.setItem('QuickOrder', 'heatvision');
  // }

  // clearData() {
  //  localStorage.clear()
  // }

  // alertMessage(event: StorageEvent) {
  //  if (event.storageArea == localStorage) {
  //    alert("IF Test = " + localStorage.getItem("QuickOrder"));
  //  }
  //  else {
  //    alert("ELSE Test = " + localStorage.getItem("QuickOrder"));
  //  }

  // }
}
